// removed by extract-text-webpack-plugin
module.exports = {"app":"App---app---3M5AC_1"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[name]---[local]---[hash:base64:5]_1","importLoaders":true,"camelCase":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5abd4551","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./client/masteradmin/App.vue
// module id = 9adY
// module chunks = 1